/**
 * Remove Rule Book section citations from text shown to affiliates and operators.
 * Internal rule ids still travel on API errors; they are not rendered in the UI.
 */

import { stripRuleReferences } from '@affdice/rules/rule-references';

export { stripRuleReferences, stripRuleReferencesDeep } from '@affdice/rules/rule-references';

/**
 * One piece of a sentence that is built from several children.
 *
 * `stripRuleReferences` ends by trimming, which is right for a whole string
 * and wrong for a fragment: JSX hands a component the parts around an inline
 * element as their own strings, so trimming each one ate the spaces on either
 * side of it and "API base <code>…</code> on <code>…</code>" rendered as
 * "API basehttps://…onhttps://…". The outer whitespace is put back, and a
 * fragment that was only whitespace stays a single space rather than
 * disappearing and welding its neighbours together.
 */
export function stripRuleReferencesInFragment(value: string): string {
  const core = stripRuleReferences(value);
  if (core === '') return /\s/.test(value) ? ' ' : '';
  const lead = /^\s/.test(value) ? ' ' : '';
  const tail = /\s$/.test(value) ? ' ' : '';
  return `${lead}${core}${tail}`;
}
